import React from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import { acme, acmeButtonSizeSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

/** Ghost icon button matching shadcn size="icon". */
const IconButton = React.forwardRef(function IconButton({ sx, size = 'icon', ...props }, ref) {
  const sizeSx = acmeButtonSizeSx[size] || acmeButtonSizeSx.icon;

  return (
    <MuiIconButton
      ref={ref}
      sx={mergeSx(
        {
          borderRadius: acme.radius.sm,
          color: acme.colors.mutedForegroundSolid,
          '&:hover': {
            backgroundColor: acme.colors.muted,
            color: acme.colors.foreground,
          },
        },
        sizeSx,
        sx,
      )}
      {...props}
    />
  );
});

export default IconButton;
